<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  
  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      fields: [
        {key: 'insertTime', label: '차단일시', thClass: 'col-4 text-center font-size-11', tdClass: 'text-center'},
        {key: 'ip', label: 'ip주소', thClass: 'col-4 text-center font-size-11', tdClass: 'text-center'},
        {key: 'blockCount', label: '차단된횟수', thClass: 'col text-center font-size-11', tdClass: 'text-center'},
        {key: 'btn', label: '삭제', thClass: 'col-2 text-center font-size-11', tdClass: 'text-center'},
      ],
      addIpAddress: "", // 차단할 ip주소
      blockList: [],
    };
  }
  
  export default {
    components: {
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
    },
    mounted() {
    },
    created() {
      this.first()
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
  
          // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
          if (this.login.level < 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          } else {
            this.getBlockList()
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
      getBlockList() {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_ip_block_list',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_idx": this.login.idx,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.blockList = res.data.ipBlockList
            }
          })
          .catch((error) => {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          })
        } catch (error) {
          console.log(error)
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      addBlock(val1, val2) {
        if (val2) {
          this.addIpAddress = val2
        }
        if (this.addIpAddress) {
          try {
            this.loadingBar(true)
            axios({
              method: 'POST',
              url: appConfig.fastapi + '/auth/admin_update_ip_block',
              headers: {
                'access-token': this.token
              },
              data: {
                "ip": this.addIpAddress,
                "isBlock": val1
              },
            })
            .then((res) => {
              if (res.data.type == 'success') {
                this.$notify({ type: 'success', duration: 2000, title: '성공', text: '차단되었습니다.' })
                this.getBlockList()
                this.addIpAddress = ""
              }
            })
            .catch((error) => {
              console.log(error)
              this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
            })
          } catch (error) {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          } finally {
            this.loadingBar(false)
          }
          
        }
      },
      deleteBlock(idx) {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_update_ip_block_exclude',
            headers: {
              'access-token': this.token
            },
            data: {
              "idx": idx
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.$notify({ type: 'success', duration: 2000, title: '성공', text: '제외되었습니다.' })
              this.getBlockList()
            }
          })
          .catch((error) => {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          })
        } catch (error) {
          console.log(error)
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      // 기다려주세요 loading 처리
      loadingBar(val) {
        this.$nextTick(() => {
          const preloader = document.getElementById("preloader");
          const status = document.getElementById("status");
          
          if (preloader && status) {
            if (val === true) {
              preloader.style.display = "block";
              status.style.display = "block";
            } else {
              preloader.style.display = "none";
              status.style.display = "none";
            }
          }
        });
      },
    },
  }
  </script>
  
  <template>
    <div class="rounded shadow">
      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">차단관리</h5>
        <span class="text-secondary font-size-12">
          차단된 ip들은 홈페이지 접속이 불가능합니다.</br>
          단일ip 차단 외에도 3번째 단계로만 차단 등록해도 4번째 단계 ip 전체 구간이 차단됩니다. (4번째 단계에 *표시)</br>
          ex) 116.179.37.* 등록시 116.179.37.0 ~ 116.179.37.255 까지 차단됩니다.
        </span>
        <hr class="my-2"></hr>
        <div>
          <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
              <div class="row justify-content-center">
                <div class="col-xl-6 col-md-12 col-sm-12">
                  <label for="addIpAddress" class="text-secondary admin-label">차단할 ip주소를 입력해주세요</label>
                  <div class="input-group">
                    <input
                      name="addIpAddress"
                      id="addIpAddress"
                      type="text"
                      @keyup.enter="addBlock(1, null)"
                      class="form-control pl-2 font-size-12 text-dark"
                      placeholder="ex) 116.179.37.237 또는 116.179.37.*"
                      v-model="addIpAddress"
                    />
                    <button @click="addBlock(1, null)" class="btn btn-square btn-danger btn-sm">차단등록</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
              <div class="row">
                <b-table 
                  id="blockListTable" 
                  ref="blockListTable" 
                  :fields="fields" 
                  :items="blockList" 
                  :hover="true"
                  table-class="table-sm table-responsive text-center font-size-14">
                  <!-- 신청인 -->
                  <template #cell(ip)="row">
                    <div class="text-secondary bg-white font-size-10">
                      {{ row.item.ip }}
                    </div>
                  </template>
                  <!-- 차단일자 -->
                  <template #cell(insertTime)="row">
                    <div class="text-secondary bg-white font-size-10">
                      {{ row.item.insertTime }}
                    </div>
                  </template>
                  <!-- 차단횟수 -->
                  <template #cell(blockCount)="row">
                    <div class="text-secondary bg-white font-size-10">
                      {{ row.item.blockCount }}
                    </div>
                  </template>
                  <!-- 삭제 -->
                  <template #cell(btn)="row">
                    <div class="text-secondary bg-white font-size-10">
                      <span @click="deleteBlock(row.item.idx)" class="badge badge-danger font-size-10 cursor-pointer">제외</span>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>